@if (target()) {
  <a
    class="link-hover no-underline flex flex--middle pr-xxsmall-t"
    [finLink]="target().url"
    [external]="target().external"
    [attr.target]="target().external ? '_blank' : ''"
  >
    @if (teaserTitle()) {
      <span
        class="nordic-blue-900-text text-icon-primary"
        [ngClass]="{
          'font-headline-medium': !layout(),
          'font-headline-small': layout() === 'small',
          'font-body-medium': layout() === 'xsmall',
        }"
        >{{ teaserTitle() }}
      </span>
    }
    <fcom-icon
      role="presentation"
      class="nordic-blue-900-text text-icon-primary icon-medium"
      [ngClass]="{
        'mr-small-l': !layout(),
        'mr-xsmall-l': layout() === 'small',
        'ms-xxsmall-l': layout() === 'xsmall',
      }"
      [name]="SvgLibraryIcon.ARROW_RIGHT"
    />
  </a>
}
<div class="teaserText mr-xsmall-t" [innerHTML]="teaserText() | finEmpty: false | finSafe: 'html'"></div>
